export const DISPLAY_NAME_ERROR =
  'Must be between 5 and 65 characters. Only alphanumeric characters, spaces, dashes, underscores, and commas allowed';
export const CONTACT_NAME_ERROR =
  'Must be between 2 and 30 characters. Only alphanumeric characters, spaces, dashes, underscores, and commas allowed';
export const CONTACT_TITLE_ERROR =
  'Must be between 3 and 50 characters. Only alphanumeric characters, spaces, dashes, underscores, and commas allowed';
export const FCC_ID_ERROR =
  'Must be between 2 and 50 characters. Only alphanumeric characters, spaces, dashes, and underscores allowed';
export const CONTACT_PHONE_ERROR = 'Invalid North American phone number';
export const CONTACT_EMAIL_ERROR =
  'Invalid email. Must be less than 50 characters';
export const NON_EMERGENCY_PHONE_ERROR = 'Invalid North American phone number';
export const POPULATION_ERROR = 'Must be between 10 and 99,999,999';
